import React from 'react';
import Icon from '../../../AppIcon';


const QuickActionPanel = ({ onNewScout, onScanQR, onVoiceInput, onCameraCapture }) => {
  const quickActions = [
    {
      id: 'new-scout',
      label: 'New Scout',
      icon: 'Plus',
      color: 'bg-primary',
      action: onNewScout,
      description: 'Start new startup profile'
    },
    {
      id: 'scan-qr',
      label: 'Scan QR',
      icon: 'QrCode',
      color: 'bg-accent',
      action: onScanQR,
      description: 'Scan business card or QR code'
    },
    {
      id: 'voice-input',
      label: 'Voice Note',
      icon: 'Mic',
      color: 'bg-trust',
      action: onVoiceInput,
      description: 'Record voice memo'
    },
    {
      id: 'camera',
      label: 'Capture',
      icon: 'Camera',
      color: 'bg-warning',
      action: onCameraCapture,
      description: 'Take photo evidence'
    }
  ];

  return (
    <div className="bg-card border-b border-border p-4">
      <h3 className="text-sm font-semibold text-foreground mb-3">Quick Actions</h3>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {quickActions?.map((action) => (
          <button
            key={action?.id}
            onClick={action?.action}
            className="flex flex-col items-center p-3 bg-muted hover:bg-muted/80 rounded-lg transition-all duration-200 hover:scale-105 active:scale-95"
          >
            <div className={`w-10 h-10 ${action?.color} rounded-full flex items-center justify-center mb-2`}>
              <Icon name={action?.icon} size={20} color="white" />
            </div>
            <span className="text-xs font-medium text-foreground">{action?.label}</span>
            <span className="text-xs text-muted-foreground text-center mt-1">{action?.description}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default QuickActionPanel;